export const PAGE_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  overview: 'Company Profile',
  settings: 'Settings',
  'job-listing-defaults': 'Job Listing Defaults',
  'table-formatting': 'Table Formatting',
  insurance: 'Insurance',
  'users-permissions': 'Users & Permissions',
  'email-templates': 'Email Templates',
  'client-agreements': 'Client Agreements & Terms',
  'client-profiles': 'Client Profiles',
  positions: 'Position Management',
  'dress-codes': 'Dress Codes',
  'payroll-settings': 'Payroll Settings',
  'tax-forms': 'Tax Forms',
  'employee-contracts': 'Worker Agreements',
  'worker-insurance': 'Worker Insurance',
  '1099-records': '1099 Records',
  'requirement-workforce': 'Worker Completion',
  'contract-workforce': 'Worker Agreement Acceptance',
  'data-table': 'Company Data'
};

export const LEGACY_PAGE_ALIASES: Record<string, string> = {
  templates: 'email-templates',
  'terms-conditions': 'client-agreements',
  'billing-defaults': 'client-agreements',
  'payroll-settings': 'employee-contracts',
  'rate-types': 'employee-contracts',
  'worker-agreements': 'employee-contracts'
};

export const ACCESS_LEVEL_PAGES: Record<string, Set<string>> = {
  COMPANY_ADMIN: new Set(Object.keys(PAGE_TITLES)),
  OPERATIONS_MANAGER: new Set([
    'overview',
    'data-table',
    'settings',
    'job-listing-defaults',
    'insurance',
    'email-templates',
    'client-profiles',
    'positions',
    'dress-codes',
    'tax-forms',
    'employee-contracts',
    'worker-insurance',
    'requirement-workforce',
    'contract-workforce'
  ]),
  FINANCE_MANAGER: new Set([
    'overview',
    'data-table',
    'settings',
    'job-listing-defaults',
    'client-agreements',
    'client-profiles',
    'payroll-settings',
    '1099-records'
  ])
};
